/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { IsAuthenticated } from './services/isAuthenticated';
import { InjectionToken } from '@angular/core';

export const IsAuthenticatedTokens: Map<string, InjectionToken<IsAuthenticated>> = new Map();

IsAuthenticatedTokens.set('password', new InjectionToken<IsAuthenticated>('password'));
IsAuthenticatedTokens.set('oidc', new InjectionToken<IsAuthenticated>('oidc'));
